import { ChatController, ChatMessage, TMessageType } from '@apia/ai';
import { IApiaForm } from '../../../../../../../JSApi/types';

export const capture = async (
  chatController: ChatController,
  formName?: string | HTMLElement,
): Promise<Blob> => {
  const body = document.body;
  let form: IApiaForm | Element | null = null;
  if (formName) {
    if (typeof formName === 'string') {
      const apiaForm = window.ApiaFunctions.getForm(formName);
      if (!apiaForm) throw new Error("There's no a form with such id");
      form = apiaForm.formElement;
      const hasAccordion = form.closest('.accordionElement');
      if (hasAccordion) {
        form = hasAccordion;
        apiaForm.openForm();
      }
    } else if (formName instanceof HTMLElement) {
      form = formName;
    }
  }
  const imageData = await new Promise<Blob>((resolve, reject) => {
    void import('html2canvas').then(({ default: html2canvas }) => {
      html2canvas(formName ? (form as HTMLElement) : body, {
        useCORS: true,
        allowTaint: true,
        logging: false,
        scrollY: -window.scrollY, // Capture content above the viewport
        windowWidth: document.documentElement.scrollWidth,
        windowHeight: document.documentElement.scrollHeight,
      })
        .then((canvas) => {
          canvas.toBlob((blob) => {
            if (!blob) return reject(new Error('Failed to create blob'));
            resolve(blob);
          }, 'image/png');
        })
        .catch((error) => {
          chatController.addMessage(
            new ChatMessage(
              'msgAiManualGenerationError',
              'error' as TMessageType,
            ),
          );
          reject(error);
          throw new Error(error);
        })
        .finally(() => {});
    });
  });
  return imageData as Blob;
};
